// extracted by mini-css-extract-plugin
module.exports = {"maincontainer":"User_maincontainer__2PnqW","header":"User_header__2u0Jm","button":"User_button__xWOHg","holder":"User_holder__2bSvw"};